const data = {
  id: "information_warfare",
  title: "Information Warfare",
  intro: "Don't worry, trickle-down economics works — we just have to wait for them to get to Mars first. In the meantime, AI will build the houses and data centers will keep us warm during the nuclear fallout. The narratives, the money behind them, and what the record actually shows.",
  tabs: [
    {
      id: "narrative_control",
      label: "Narrative Control",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "disinformation",
      label: "Disinformation Campaigns",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "media_capture",
      label: "Media Capture",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
